// extracted by mini-css-extract-plugin
module.exports = {"VolumeRange":"VolumeRange__VolumeRange__xxyoB"};